import { normalizeJoinCode } from "@vocifuchs/shared";
import type { ClassPreview } from "../lib/join.js";
import { auth } from "../copy/auth.js";
import { common } from "../copy/common.js";
import { Field, inputClass } from "./ui.js";

/**
 * The class code, with the class name right under it once the code is
 * complete (issue #42). Used on «Konto anlegen» with a code and on «Klasse
 * beitreten»; both fill it from a class link (issue #48).
 */
export function ClassCodeField({
  label,
  hint,
  value,
  onChange,
  preview,
}: {
  label: string;
  hint?: string;
  value: string;
  onChange: (code: string) => void;
  preview: ClassPreview;
}) {
  return (
    <div className="space-y-2">
      <Field label={label} hint={hint}>
        <input
          className={`${inputClass()} font-mono tracking-[0.2em] uppercase`}
          value={value}
          onChange={(e) => onChange(normalizeJoinCode(e.target.value))}
          required
          minLength={8}
          maxLength={8}
          autoCapitalize="characters"
          autoComplete="off"
          spellCheck={false}
          aria-describedby="class-preview"
        />
      </Field>
      <p id="class-preview" aria-live="polite" className="min-h-6 text-sm">
        {preview.state === "checking" ? (
          <span className="text-ink-soft">{common.loading}</span>
        ) : preview.state === "found" ? (
          <span className="font-semibold text-moss">{auth.join.preview(preview.name)}</span>
        ) : preview.state === "unknown" ? (
          <span className="font-semibold text-rose">{preview.message}</span>
        ) : null}
      </p>
    </div>
  );
}
